export default "__VITE_ASSET__B7sLL7n1__"